export const API_BASE_URL = process.env.BUN_PUBLIC_API_BASE_URL || 'http://localhost:3000/api';
export const TOKEN_KEY = process.env.BUN_PUBLIC_TOKEN_KEY || 'jwt_token';
